import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from 'app/main/shared/services/api.service';
import { ProposalService } from './proposal.service';
import { PurchasedSalesPackageService } from './purchasedSalesPackage.service';

@Injectable({
  providedIn: 'root'
})
export class AgendaService implements Resolve<any> {



  constructor(
    private api: ApiService,
    private router: Router,
    private purchasedSalesPackageService: PurchasedSalesPackageService,
    private proposalService: ProposalService
  ) {

  }

  async resolve(
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const resolved: any = {};
      if ((state.url.includes('public-area') && state.url.includes('zoomvideocall'))) {
        if (state.url.includes('startProposalVideoCall')) {
          await this.baseCheck(route, state);
          const resp: any = await this.startProposalVideoCall(route.params.agendaItemId, route.params.ep);
          resolved.redirectUrl = resp.payload.startUrl;
        } else if (state.url.includes('joinProposalVideoCall')) {
          await this.baseCheck(route, state);
          const resp: any = await this.joinProposalVideoCall(route.params.agendaItemId, route.params.ep);
          resolved.redirectUrl = resp.payload.joinUrl;
        } else if (state.url.includes('startPurchasedSalesPackageVideoCall')) {
          await this.baseCheck(route, state);
          const resp: any = await this.startPurchasedSalesPackageVideoCall(route.params.agendaItemId, route.params.ep);
          resolved.redirectUrl = resp.payload.startUrl;
        } else if (state.url.includes('joinPurchasedSalesPackageVideoCall')) {
          await this.baseCheck(route, state);
          const resp: any = await this.joinPurchasedSalesPackageVideoCall(route.params.agendaItemId, route.params.ep);
          resolved.redirectUrl = resp.payload.joinUrl;
        }
      }
      else if ((state.url.includes('common-area') && state.url.includes('agenda/') && state.url.includes('/items'))) {
        if (route.queryParams.purchasedSalesPackageId) {
          const respo: any = await this.purchasedSalesPackageService.getPurchasedSalesPackage(
            route.queryParams.purchasedSalesPackageId
          );
          resolved.purchasedSalesPackage = respo.payload;
        }


        if (route.queryParams.proposalId) {
          const respo2: any = await this.proposalService.getProposal(
            route.queryParams.proposalId
          );
          resolved.proposal = respo2.payload;
        }
        if (route.queryParams.agendaItemId) {
          const respo3: any = await this.getAgendaItem(
            route.queryParams.agendaItemId
          );
          resolved.agendaItem = respo3.payload;
          resolved.openViewAgendaItemModal = route.queryParams.openViewAgendaItemModal;
        }
      }
      return resolved;
    } catch (err) {
      this.router.navigateByUrl(``);
    }
  }

  async baseCheck(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const agendaItemId = route.params.agendaItemId;
    if (!agendaItemId) {
      this.router.navigateByUrl(``);
    }
    if (!route.params.ep) {
      this.router.navigateByUrl(``);
    }
    const respo: any = await this.checkAgendaItem(
      agendaItemId
    );
  }

  async checkAgendaItem(agendaItemId) {
    return this.api.getRequestPromise(`public/agenda/item/${agendaItemId}/check`);
  }

  async getAgendaItem(agendaItemId) {
    return this.api.getRequestPromise(`agenda/item/${agendaItemId}`);
  }

  async createAgendaItem(agendaItem) {
    return this.api.postRequestPromise(`agenda/item`, agendaItem);
  }

  async editAgendaItem(agendaItem) {
    return this.api.putRequestPromise(`agenda/item`, agendaItem);
  }

  async deleteAgendaItem(agendaItemId) {
    return this.api.deleteRequestPromise(`agenda/item/${agendaItemId}`);
  }

  async startProposalVideoCall(agendaItemId, ep) {
    let url = `public/proposal/agenda/item/${agendaItemId}/ep/${ep}/startVideoCall`;
    return this.api.putRequestPromise(url, {});
  }

  async joinProposalVideoCall(agendaItemId, ep) {
    let url = `public/proposal/agenda/item/${agendaItemId}/ep/${ep}/joinVideoCall`;
    return this.api.putRequestPromise(url, {});
  }

  async startPurchasedSalesPackageVideoCall(agendaItemId, ep) {
    let url = `public/purchasedsalespackage/agenda/item/${agendaItemId}/ep/${ep}/startVideoCall`;
    return this.api.putRequestPromise(url, {});
  }

  async joinPurchasedSalesPackageVideoCall(agendaItemId, ep) {
    let url = `public/purchasedsalespackage/agenda/item/${agendaItemId}/ep/${ep}/joinVideoCall`;
    return this.api.putRequestPromise(url, {});
  }

  async retrieveStartProposalVideoCall(agendaItemId) {
    let url = `proposal/agenda/item/${agendaItemId}/retrieveStartUrl`;
    return this.api.getRequestPromise(url);
  }

  async retrieveJoinProposalVideoCall(agendaItemId) {
    let url = `proposal/agenda/item/${agendaItemId}/retrieveJoinUrl`;
    return this.api.getRequestPromise(url);
  }

  async retrieveStartPurchasedSalesPackageVideoCall(agendaItemId) {
    let url = `purchasedsalespackage/agenda/item/${agendaItemId}/retrieveStartUrl`;
    return this.api.getRequestPromise(url);
  }

  async retrieveJoinPurchasedSalesPackageVideoCall(agendaItemId) {
    let url = `purchasedsalespackage/agenda/item/${agendaItemId}/retrieveJoinUrl`;
    return this.api.getRequestPromise(url);
  }

  async retrieveAgendaItems(purchasedSalesPackage, proposal, filterString, pageIndex, pageSize, sortField, sortDirection) {
    if (!filterString) {
      filterString = ''
    };
    if (!pageIndex) {
      pageIndex = 0
    }
    if (!pageSize) {
      pageSize = 10
    }
    let filterPurchasedSalesPackageId = '';
    if (purchasedSalesPackage) {
      filterPurchasedSalesPackageId = purchasedSalesPackage.id;
    }
    let filterProposalId = '';
    if (proposal) {
      filterProposalId = proposal.id;
    }
    // const url = this.propostaBasePath + `?filterString=${filterString}&pageIndex=${pageIndex}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`;
    const url = `agenda/paged/items?filterPurchasedSalesPackageId=${filterPurchasedSalesPackageId}&filterProposalId=${filterProposalId}&filterString=${filterString}&pageIndex=${pageIndex}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`;
    return this.api.getRequestPromise(url);
  }

  async manageZoomRegistrants(agendaItemId: any, zoomMeetingRegistrants: any[]) {
    return this.api.putRequestPromise(`purchasedsalespackage/agenda/${agendaItemId}/items/manageZoomRegistrants`, zoomMeetingRegistrants);
  }

  async resendUrlToUsersForAgendaItem(agendaItemId: any, zoomMeetingRegistrantsEmails: any[]) {
    return this.api.putRequestPromise(`purchasedsalespackage/agenda/${agendaItemId}/items/resendUrlToUsersForAgendaItem`, zoomMeetingRegistrantsEmails);
  }

  async getCalendarEvents(from?, to?) {
    if (from && to) {
      return this.api.getRequestPromise(`agenda/items?from=${from}&to=${to}`);
    } else {
      return this.api.getRequestPromise(`agenda/items`);
    }
  }

  //OLD probabilmente serviranno
  async startLesson(userSubjectAvailabilityId) {
    return this.api.postRequestPromise(`agenda/${userSubjectAvailabilityId}/startLesson`, {});
  }


  //OLD probabilmente non serviranno
  async newAgendaFromProfessorAvailability(obj) {
    return this.api.postRequestPromise(`agenda/create/fromProfessorAvailability`, obj);
  }


  async bestMatch(obj) {
    return this.api.postRequestPromise(`agenda/bestMatch`, obj);
  }

  async getProfessorAvailabilitiesPaged(pageIndex, pageSize) {
    return this.api.getRequestPromise(`agenda/getUserSubjectAvailabilityGrouped?pageInded=${pageIndex}&pageSize=${pageSize}`);
  }

  async deleteProfessorAvailabilities(fromDate, toDate, subjectId) {
    return this.api.deleteRequestPromise(`agenda/deleteUserSubjectAvailabilityInDataRange?fromDate=${fromDate}&toDate=${toDate}&subjectId=${subjectId}`);
  }

  async deleteProfessorAvailability(availabilityId) {
    return this.api.deleteRequestPromise(`usersubjectavailability/` + availabilityId);
  }
  async newSingleAvailability(availability) {
    return this.api.postRequestPromise(`usersubjectavailability/`, availability);
  }
  async editSingleAvailability(availability) {
    return this.api.putRequestPromise(`usersubjectavailability`, availability);
  }
}
